<template>
  <div class="edition-table">
    <b-row>
      <b-col cols="11">
        <table>
          <thead>
            <th class="edition-table__medium">
              Tipo
              <InfoTooltip
                text="Tipo de hóspede, de acordo com configuração de pax."
                :tooltipMinWidth="175"
              />
            </th>

            <th class="edition-table__large">
              Tipo de valor
              <InfoTooltip
                text="Se os valores para créscimo em relação à tarifa base, representam um valor monetário absoluto ou percentual."
                :tooltipMinWidth="206"
              />
            </th>

            <th
              v-for="(item, i) in getMaxOverral"
              :key="`th-${i}`"
              class="edition-table__small"
            >
              Valor {{ i + 1 }}° adicional
              <InfoTooltip
                text="Valor a ser acrescido para o primeiro PAX adicional em relação à quantidade base do quarto."
                :tooltipMinWidth="159"
              />
            </th>
          </thead>
          <tbody>
            <!-- LINHA -->
            <tr
              v-for="(item, i) in getUniqueItens"
              :key="`item-${item.codigoQuarto || i}`"
            >
              <!-- TIPO DE USUÁRIO -->
              <td class="td__padd">{{ item.nomePax }}</td>

              <!-- TIPO DE VALOR -->
              <td class="td__padd">
                <PmwFormSelect
                  :value="item.selectedValueType"
                  :options="valueTypeOptions"
                  label=""
                  placeholder="Selecione o tipo do valor"
                  class="edition-table--select"
                  @change="selectValue($event, item)"
                />
              </td>

              <!-- VALOR -->
              <td
                v-for="(ocupante, j) in getItemArray(item.codigoPax)"
                :key="`pax-${j}`"
                class="td__padd"
              >
                <PmwFormInput
                  v-if="ocupante.tipoValor === 1"
                  v-model="ocupante.valorAdicional"
                  type="number"
                  label=""
                  placeholder="0"
                  size="small"
                  sufix="%"
                  class="form--input"
                />

                <!-- INPUT DE PREÇO -->
                <PmwFormCurrencyInput
                  v-if="ocupante.tipoValor === 2"
                  v-model="ocupante.valorAdicional"
                  :options="{ precision: 2 }"
                  size="small"
                  label=""
                  placeholder="00,00"
                  prefix="R$"
                  type="number"
                  class="edition-table__input"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>

      <b-col class="remove-col" cols="1">
        <button class="remove-col--btn" @click="$emit('closeInputs', $event)">
          <Icon icon="x-icon" />
        </button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/** ======================================================= */
/** Componente da tabela de visualização de edição de diferenciais por usuário */
/** ======================================================= */
import PmwFormSelect from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormSelect'
import PmwFormCurrencyInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormCurrencyInput'
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'
import InfoTooltip from '@solucoes/components-lib-tmp/src/components/patterns/InfoTooltip'

export default {
  name: 'AdditionalPaxInputs',
  components: {
    PmwFormSelect,
    PmwFormCurrencyInput,
    InfoTooltip,
    PmwFormInput
  },

  props: {
    boardData: {
      type: Array
    },

    maxAdults: {
      type: Number,
      default: 0
    },

    maxChildren: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      novoArrayAgrupado: [],
      valueTypeOptions: [
        { text: 'Percentual', value: 1 },
        { text: 'Absoluto', value: 2 }
      ]
    }
  },

  computed: {
    getMaxOverral() {
      if (this.maxAdults >= this.maxChildren) {
        return this.maxAdults
      } else if (this.maxChildren >= this.maxAdults) {
        return this.maxChildren
      }

      return 0
    },

    getUniqueItens() {
      return this.boardData.filter((item, index, arr) => {
        if (index === 0) {
          return item
        }

        return arr[index - 1].codigoPax !== item.codigoPax
      })
    }
  },

  async created() {
    await this.boardData.forEach((item) => {
      if (typeof item.tipoValor === 'number') {
        item.selectedValueType = this.valueTypeOptions.find(
          (opcao) => opcao.value === item.tipoValor
        )
      }
    })
  },

  methods: {
    getItemArray(codigoPax) {
      return this.boardData.filter((item) => item.codigoPax === codigoPax)
    },

    /**
     * Determina o valor do tipoValor de todos os itens do tipo de produto.
     * @param {Object} $event - Valor selecionado do tipo de valor.
     * @param {Object} pax - Pax selecionado.
     */
    selectValue($event, pax) {
      this.boardData.forEach((item) => {
        if (item.codigoPax === pax.codigoPax) {
          item.tipoValor = $event.value
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$cell-padding: 17px 7px 15px 15px;
$cell-inputs-padding: 25px 15px;

.form {
  &--input {
    width: 100px;
    /** Alterar cores novas do select */
    ::v-deep {
      .pmw-form-field--label {
        font-weight: font-weight('weight-medium');
      }
      .form-field--label-wrapper {
        line-height: 21px;
        margin-bottom: 3px;
      }
      .pmw-input {
        background: $white;
      }
      .pmw-input--clear {
        z-index: 0;
      }
      .pmw-input__focus {
        border-color: $pmw-blue;
      }

      .pmw-input--field {
        background: $pmw-white;

        &:focus {
          border-color: $pmw-blue;
        }
      }

      .pmw-input__disabled {
        input {
          background: pmw-colors('grey-20');
          color: $pmw-gray-darker;
        }
      }

      .pmw-custom-tooltip {
        line-height: 18px;
      }
    }
  }
}

::v-deep {
  .pmw-form-field--label {
    display: none;
  }
}

.edition-table {
  max-width: 1236px;

  .remove-col {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;

    &--btn {
      @include reset-button();

      .icon {
        width: 12px;
        height: 12px;
        color: $gray-dark;
        transition: color 0.8s;

        &:hover {
          color: red;
        }
      }
    }
  }

  &--select {
    max-width: 210px;

    /** Alterar cores novas do select */
    ::v-deep {
      .pmw-select--button__caret-sort-up,
      .pmw-select--button__show {
        border-bottom-color: pmw-colors('blue-100');
      }
      .pmw-select--button {
        padding: 0 2px;
      }
      .pmw-select--button:focus {
        border-color: pmw-colors('blue-100');
        border-bottom-color: pmw-colors('blue-100');
      }
      .pmw-select-options--item__hover:hover,
      .pmw-select-options--item__checked {
        background-color: pmw-colors('blue-100') !important;
      }

      .pmw-label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  &__input {
    width: 100px;
  }

  &__medium {
    width: 160px;
    min-width: 150px;
  }

  &__large {
    width: 208px;
    min-width: 208px;
  }

  &__small {
    width: 115px;
    min-width: 115px;
  }

  table {
    th {
      padding: $cell-padding;
    }

    th,
    td {
      vertical-align: middle;
      border: 1px solid $gray-border;
      font-size: font-size('size-small');
      font-weight: font-weight('weight-medium');
      white-space: nowrap;

      & + & {
        border-left: none;
      }

      &.empty {
        background-color: $gray-lightest;
      }
    }

    th {
      font-weight: font-weight('weight-medium');
    }

    .td {
      padding: 0;
      min-width: 1px;

      &__padd {
        padding: $cell-inputs-padding;
        ::v-deep {
          .input-checkbox {
            margin: 0px auto !important;
            display: table;
          }
        }
      }
    }

    .rest-td {
      .td {
        &:first-child {
          border-right: 1px solid $gray-border;
        }

        &:last-child {
          ::v-deep {
            .content-wrapper {
              padding: {
                left: 10px;
                right: 10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
